import React from 'react';

export function PageLoader({ label = 'Loading...' }) {
  return (
    <div className="page-loader">
      <div className="spinner" />
      <span>{label}</span>
    </div>
  );
}
